import React from 'react';

/**
 * Dumb <br /> component for get around of i18next errors
 * @returns {JSX.Element}
 */
export const Br = () => <br />;
